<div class="search">
  <div class="search-text">Search for breeds</div>
  <div class="search-box">
    <form ngNativeValidate>
      <input
        type="text"
        name="term"
        required
        ngModel
        class="search-txt"
        (keyup)="searchTerm$.next($event.target.value)"
      />
    </form>
  </div>
</div>
<div class="search-results">
  <ul *ngIf="results">
    <li *ngFor="let result of results | slice: 0:9">
      <a
        routerLinkActive="active"
        routerLink="{{ result.id }}"
        class="cat-search"
      >
        {{ result.name }}
      </a>
    </li>
  </ul>
</div>
